import React, { Component } from 'react'
import request from "../../../lib/requester";
import _, { toNumber } from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Loader } from "react-overlay-loader";

class ClaimDetailCHD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      General_SkpNumber: "",
      General_ProgramNumber: "",
      General_Principal: "",
      General_ReffNumber: "",
      General_ProgramType: "",
      General_ProgramDescription: "",
      General_BudgetType: "",
      General_AssignmentType: "",
      General_ProgramSubmittedDate: "",
      General_StartDate: "",
      General_EndDate: "",
      General_ClaimExpDate: "",
      General_Budget: "",
      General_BudgetRemaining: "",
      General_SalesTarget: "",
      General_CustomerPPHType: "",
      General_PPhRate: "",
      General_PrincipalCode: "",
      General_Program_ID: '',
      Customer_Id: "",
      Customer_Name: "",
      Customer_NPWP: "",
      Customer_NPWPName: "",
      Customer_NPWPAddress: "",
      Customer_BankName: "",
      Customer_BankAccountNo: "",
      Customer_BankAccountOwner: "",
      Customer_Potong_Pajak: "",
      Customer_PKP_Badan: "",
      Claim_Branch: "",
      Claim_PaymentMethod: "TRF",
      Claim_Activity: "",
      Claim_CostCenter: "",
      Claim_DPP: "",
      Claim_PPh: "",
      Claim_PPhRate: "",
      Claim_PPn: "",
      ppnrate: 10,
      Claim_TaxNo: "",
      Claim_TotalAmount: "",
      Claim_SKB: "",
      Claim_CustomerReceipt: "",
      Claim_TotalSales: "",
      Claim_TaxDate: "",
      Claim_SKBNumber: "",
      Claim_PPh_Type: "",
      Claim_Source_DWH: "N",
      Claim_Period_Month: "",
      Claim_Period_Year: "",
      Claim_Period_Type: "",
      Claim_Package: "",
      Claim_SKB_Start_Date: "",
      Claim_SKB_End_Date: "",
      Claim_Bukpot: 0,
      Claim_Nett: 0,
      Attachment_Display: "N",
      Attachment_Data: "N",
      Attachment_Jml_Data: "0",
      Attachment_Jml_Display: 0,
      Show_Display_Upload: false,
      Attachment: [],
      Product_List: [],
      lovActivity: [],
      lovCostCenter: [],
      lovPPhType: [],
      lovPackage: [],
      Document_List: [],
      Document_Selected: [],
      fileRequired: { filename: "", path: "" },
      fileSKB: { filename: "", path: "" },
      error: [],
      dataInsentif: [],
      success: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      notes: "",
      currentQuartal: 0
    };
  }

  componentDidMount = () => {
    this.getClaimData();
    this.getMasterData();
    this.getPPNRATE(new Date());
  };

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return (
                <li key={index}>
                  <i className="fas fa-exclamation-triangle" /> {item}
                </li>
              );
            })}
          </ul>
        </div>
      );
    }
  };

  getMasterData = () => {
    let url = "/api/traces_chd/v1/program/data-master";
    request.getCHD(url, {
      success: function (response) {
        let { ProgramPPhType } = response.data.data;
        this.setState({
          lovPPhType: ProgramPPhType,
        });
      }.bind(this),
      error: function (e) {
        console.log(e.message);
      },
    });
  };

  getClaimData = () => {
    let url = "/api/traces_chd/v1/claim/data-claim-by-program-customer";
    let { id } = this.props.match.params;
    let param = {
      program_customer_id: id,
    };

    this.setState({ loading: true });
    request.postCHD(url, param, {
      success: function (response) {
        let {
          Program,
          Document,
          Package,
          Participant,
          Product,
          Activity,
          CostCenter,
        } = response.data.data;

        // Rebuild Product
        let NewProduct = Product.map((item, index) => {
          item.item_actual = "0";
          return item;
        });
        this.setDefaultValue(Program);
        
        this.setState({
          loading: false,
          Product_List: NewProduct,
          lovActivity: Activity,
          lovCostCenter: CostCenter,
          lovPackage: Package,
          Document_List: Document,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
        console.log(e.message);
      }.bind(this),
    });
  };

  getPPNRATE = (taxdate) => {
    let url = "/api/traces/v1/claim/get-ppn-rate-oracle";
    let { id } = this.props.match.params;
    let param = {
      program_customer_id: id,
      tax_date: taxdate,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { ppnrate } = response.data.data;
        this.setState({
          ppnrate: ppnrate,
        });
        this.setState({ loading: false });
        // this.getInvoice();
        // this.getNpwp();
        let app = this;
        window.setTimeout(() => {
          // app.calculateAmount();
          this.setState({ loading: false });
        }, 200);
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  setDefaultValue = (data) => {
    this.setState({
      General_PrincipalCode: data.org_initial,
      General_SkpNumber: data.skp_number,
      General_ProgramNumber: data.program_number,
      General_Principal: data.org_name,
      General_ReffNumber: data.ref_number,
      General_ProgramType: data.program_name,
      General_ProgramDescription: data.description,
      General_BudgetType: data.budget_type,
      General_AssignmentType: data.customer_assignment_type,
      General_Program_ID: data.program_id,
      General_ProgramSubmittedDate: data.creation_date
        ? moment(data.creation_date).format("DD-MMM-YYYY")
        : "",
      General_StartDate: data.start_date
        ? moment(data.start_date).format("DD-MMM-YYYY")
        : "",
      General_EndDate: data.end_date
        ? moment(data.end_date).format("DD-MMM-YYYY")
        : "",
      General_ClaimExpDate: data.claim_exp_date
        ? moment(data.claim_exp_date).format("DD-MMM-YYYY")
        : "",
      General_Budget: data.budget ? this.thousandSeparator(data.budget) : "0",
      General_BudgetRemaining: data.sisa_budget
        ? this.thousandSeparator(data.sisa_budget)
        : "0",
      General_SalesTarget: data.sales_target
        ? this.thousandSeparator(data.sales_target)
        : "0",
      General_CustomerPPHType: data.pph_type,
      General_PPhRate: data.pph_rate,
      Customer_Id: data.customer_id,
      Customer_Name: data.customer_name || "",
      Customer_NPWP: data.npwp || "",
      Customer_NPWPAddress: data.npwp_address || "",
      Customer_NPWPName: data.npwp_name || "",
      Customer_BankName: data.bank_name || "",
      Customer_BankAccountNo: data.bank_account_no || "",
      Customer_BankAccountOwner: data.bank_account_owner || "",
      Customer_Potong_Pajak: data.potong_pajak,
      Customer_PKP_Badan: data.pkp_badan,
      Claim_PPhRate: data.customer_pph_rate,
      Attachment_Display: data.display,
      Attachment_Data: data.additional_data,
      Claim_Source_DWH: data.source_dwh,
      Claim_PPh_Type: data.customer_pph_type,
      Claim_Package: data.package,
      Claim_Branch: data.branch_code,
      currentQuartal: data.start_date ? moment(data.start_date).quarter() : 0,
      Claim_Period_Year: data.start_date ? moment(data.start_date).format('YYYY') : '',
      Claim_Period_Type: 'Q',
      Claim_Period_Month: data.start_date ? moment(data.start_date).quarter() : 0
      // ppnrate: data.ppnrate,
    }, () => {
      if(data.program_name == 'BRANDING RELASI') this.handleCalculateDPP();
    });
  };

  renderGeneralInfo = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          {this.showNotification()}
          <div className="card">
            <div className="card-header bg-light">
              <a
                className="text-decoration-none text-dark font-size-title"
                data-toggle="collapse"
                href="#multiCollapseExample2"
                role="button"
                aria-expanded="true"
                aria-controls="multiCollapseExample2"
              >
                General Info{" "}
                <i className="fas fa-chevron-down font-size-small text-muted" />
              </a>
            </div>
            <div className="multi-collapse collapse" id="multiCollapseExample2">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">SKP Number</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_SkpNumber}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Number</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_ProgramNumber}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Principal</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_Principal}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Reff Number / SKP</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_ReffNumber}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Type</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_ProgramType}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">
                        Program Description
                      </label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_ProgramDescription}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget Type</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_BudgetType}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Customer Assignment Type</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_AssignmentType}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Start Date</label>
                      <input
                        type="text"
                        className="form-control col-md-3"
                        disabled={true}
                        value={this.state.General_StartDate}
                      />
                      <label className="col-md-2 mt-1">End Date</label>
                      <input
                        type="text"
                        className="form-control col-md-3"
                        disabled={true}
                        value={this.state.General_EndDate}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Claim Exp Date</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_ClaimExpDate}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_Budget}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget Remaining</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_BudgetRemaining}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Sales Target</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_SalesTarget}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Customer PPH Type</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_CustomerPPHType}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">PPh Rate (%)</label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_PPhRate}
                      />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">
                        Program Submitted Date
                      </label>
                      <input
                        type="text"
                        className="form-control col-md-8"
                        disabled={true}
                        value={this.state.General_ProgramSubmittedDate}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderCustomerInfo = () => {
    return (
      <div className="card">
        <div className="card-header bg-light">
          <a
            className="text-decoration-none text-dark font-size-title"
            data-toggle="collapse"
            href="#multiCollapseExample1"
            role="button"
            aria-expanded="false"
            aria-controls="multiCollapseExample1"
          >
            Customer Info{" "}
            <i className="fas fa-chevron-down font-size-small text-muted" />
          </a>
        </div>
        <div className="multi-collapse show" id="multiCollapseExample1">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Customer</label>
                  <input
                    type="text"
                    className="form-control col-md-8"
                    disabled={true}
                    value={this.state.Customer_Name}
                  />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">NPWP Name</label>
                  <input
                    type="text"
                    className="form-control col-md-8"
                    disabled={true}
                    value={this.state.Customer_NPWPName}
                  />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">NPWP Address</label>
                  <input
                    type="text"
                    className="form-control col-md-8"
                    disabled={true}
                    value={this.state.Customer_NPWPAddress}
                  />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">NPWP / NIK</label>
                  <input
                    type="text"
                    className="form-control col-md-8"
                    disabled={true}
                    value={this.state.Customer_NPWP}
                  />
                </div>
                <div hidden className="form-group row">
                  <label className="col-md-4 mt-1">Potong Pajak</label>
                  <div className="col-md-8">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="customRadioInline1"
                        name="customRadioInline1"
                        className="custom-control-input"
                        disabled={true}
                        value="Y"
                        checked={
                          this.state.Customer_Potong_Pajak === "Y"
                            ? true
                            : false
                        }
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="customRadioInline1"
                      >
                        Ya
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="customRadioInline2"
                        name="customRadioInline2"
                        className="custom-control-input"
                        disabled={true}
                        value="N"
                        checked={
                          this.state.Customer_Potong_Pajak === "N" ||
                          this.state.Customer_Potong_Pajak === null
                            ? true
                            : false
                        }
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="customRadioInline2"
                      >
                        Tidak
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-md-4 mt-1">PKP Badan</label>
                  <div className="col-md-8">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="customRadioInline3"
                        name="customRadioInline3"
                        className="custom-control-input"
                        disabled={true}
                        value="Y"
                        checked={
                          this.state.Customer_PKP_Badan === "Y" ? true : false
                        }
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="customRadioInline1"
                      >
                        Ya
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="customRadioInline4"
                        name="customRadioInline4"
                        className="custom-control-input"
                        disabled={true}
                        value="N"
                        checked={
                          this.state.Customer_PKP_Badan === "N" ||
                          this.state.Customer_PKP_Badan === null
                            ? true
                            : false
                        }
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="customRadioInline2"
                      >
                        Tidak
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Bank Name</label>
                  <input
                    type="text"
                    className="form-control col-md-8"
                    disabled={true}
                    value={this.state.Customer_BankName}
                  />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Bank Account No</label>
                  <input
                    type="text"
                    className="form-control col-md-8"
                    disabled={true}
                    value={this.state.Customer_BankAccountNo}
                  />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Bank Account Owner</label>
                  <input
                    type="text"
                    className="form-control col-md-8"
                    disabled={true}
                    value={this.state.Customer_BankAccountOwner}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name === "Claim_PPh" || name === "Claim_PPn" || name === "Claim_DPP") {
      value = this.thousandSeparator(value);
    } else if (name === "Claim_PPhRate") {
      value = value.replace(/[^0-9.]/g, "").replace(/\./g, "");
      if (parseInt(value) > 100) value = 100;
      if (parseInt(value) < 0) value = 0;
    }

    this.setState({ [name]: value });
    // if (name === "Claim_PPh" || name === "Claim_PPn" || name === "Claim_DPP" || name === "Claim_PPhRate") {
    if (
      name === "Claim_PPh" ||
      name === "Claim_PPn" ||
      name === "Claim_PPhRate"
    ) {
      let app = this;
      if (name === "Claim_DPP") {
        // let ppn = this.thousandSeparator(parseFloat(this.removeSeparator(value)) / 10); // penambahan math round
        let ppn = this.thousandSeparator(
          (parseFloat(this.removeSeparator(value)) * this.state.ppnrate) / 100
        );

        app.setState({ Claim_PPn: ppn });
        window.setTimeout(() => {
          app.countPPH();
        }, 100);
      } else if (name === "Claim_PPhRate") {
        window.setTimeout(() => {
          app.countPPH();
        }, 100);
      }
      window.setTimeout(() => {
        app.calculateAmount();
        app.forceUpdate();
      }, 100);
    }

    if (name === "Claim_PPh_Type") {
      let find = _.find(this.state.lovPPhType, function (o) {
        return o.pph_type === value;
      });
      if (find) {
        this.setState({ Claim_PPhRate: find.pph_rate });
        let app = this;
        window.setTimeout(function () {
          app.calculateTotalClaim();
        }, 200);
      }
    }
  };

  renderSKBAttachment = () => {
    if (this.state.Claim_SKB === "Y") {
      return (
        <input
          type="file"
          data-type="SKB"
          onChange={this.handleUploadSingle.bind(this)}
        />
      );
    }
  };

  renderSKBPeriod = () => {
    if (this.state.Claim_SKB === "Y") {
      return (
        <div className="form-group row">
          <label className="col-md-4 mt-1">Start Date</label>
          <div className="col-md-3 p-0">
            <DatePicker
              selected={this.state.Claim_SKB_Start_Date}
              dateFormat="d-MMM-yyyy"
              className="form-control"
              popperPlacement="top-end"
              onChange={this.handleSKBDateStart}
            />
          </div>
          <label className="col-md-2 mt-1">End Date</label>
          <div className="col-md-3 p-0">
            <DatePicker
              selected={this.state.Claim_SKB_End_Date}
              dateFormat="d-MMM-yyyy"
              className="form-control"
              popperPlacement="top-end"
              onChange={this.handleSKBDateEnd}
            />
          </div>
        </div>
      );
    }
  };

  handleClickSKB = (e) => {
    let value = e.target.value;
    let isChecked = e.target.checked;
    if (isChecked) {
      let find = _.find(this.state.lovPPhType, function (o) {
        return o.pph_type === 'PPh23_0%';
      });
      if (find) {
        this.setState({ Claim_SKB: value, Claim_PPh_Type: 'PPh23_0%', Claim_PPhRate: find.pph_rate });
      }
    } else {
      this.setState({
        Claim_SKB: "N",
        Claim_SKB_Start_Date: '',
        Claim_SKB_End_Date: '',
        Claim_PPh_Type: '',
        Claim_PPhRate: 0
      });
      this.countPPH();
    }
    window.setTimeout(() => {
      this.calculateTotalClaim();
    }, 200);
    // window.setTimeout(() => {
    //   app.calculateAmount();
    // }, 200);
  };

  renderSKBNumber = () => {
    if (this.state.Claim_SKB === "Y") {
      return (
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            SKB Number
          </label>
          <input
            type="text"
            autoComplete="off"
            className="form-control col-md-8"
            id="inputEmail3"
            name="Claim_SKBNumber"
            placeholder=""
            onChange={this.handleChangeInput.bind(this)}
            value={this.state.Claim_SKBNumber}
          />
        </div>
      );
    }
  };

  handleUploadSingle = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    let doctype = e.target.dataset.type;
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = [
      "jpg",
      "png",
      "jpeg",
      "gif",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "csv",
      "pdf",
    ];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyCHD("/api/traces_chd/v1/util/upload-file", data, {
      success: function (response) {
        let data = response.data;

        if (doctype === "SKB") {
          let { fileSKB } = this.state;
          fileSKB.filename = data.filename;
          fileSKB.path = data.fullurl;
          this.setState(fileSKB);
        } else if (doctype === "REQUIRED") {
          let { fileRequired } = this.state;
          fileRequired.filename = data.filename;
          fileRequired.path = data.fullurl;
          this.setState(fileRequired);
        }
        this.setState({ loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
        console.log(e.message);
      }.bind(this),
    });
  };

  countPPH = () => {
    let { Claim_DPP, Claim_PPhRate } = this.state;
    let countPPH =
      (parseInt(Claim_PPhRate || 0) / 100) *
      parseInt(this.removeSeparator(Claim_DPP));
    let pph = this.thousandSeparator(parseFloat(countPPH));
    this.setState({ Claim_PPh: pph });
  };

  calculateAmount = () => {
    let { Claim_DPP, Claim_PPn, Claim_PPh, Claim_TotalAmount } = this.state;
    let totalAmount =
      (parseFloat(this.removeSeparator(Claim_DPP)) || 0) +
      (parseFloat(this.removeSeparator(Claim_PPn)) || 0) -
      (parseFloat(this.removeSeparator(Claim_PPh)) || 0);
    totalAmount = Math.round(totalAmount); // ilham, menambahkan round
    console.log(totalAmount);
    this.setState({
      Claim_TotalAmount: this.thousandSeparator(totalAmount),
      Claim_PPn: this.thousandSeparator(Claim_PPn),
    });
  };

  handleTaxDate = (date) => {
    console.log(date);
    this.setState({ Claim_TaxDate: date });
    
    this.getPPNRATE(date);
    
  };

  renderYear = () => {
    let thisYear = moment(new Date()).format("YYYY");
    let arrayYear = [thisYear, thisYear - 1];
    return (
      <select
        className="form-control"
        name="Claim_Period_Year"
        onChange={this.handleChangeInput.bind(this)}
        value={this.state.Claim_Period_Year}
        disabled
      >
        <option value="">- Select Year -</option>
        {arrayYear.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
      </select>
    );
  };

  renderLovPeriod = () => {
    let arrayPeriod = [
      {
        text: "Monthly",
        value: "M",
      },
      {
        text: "Quarterly",
        value: "Q",
      },
    ];
    return (
      <select
        className="form-control"
        name="Claim_Period_Type"
        onChange={this.handleChangeInput.bind(this)}
        value={this.state.Claim_Period_Type}
        disabled
      >
        <option value="">- Select Period -</option>
        {arrayPeriod.map((item, index) => (
          <option key={index} value={item.value}>
            {item.text}
          </option>
        ))}
      </select>
    );
  };

  renderMonth = () => {
    let { Claim_Period_Type } = this.state;

    let arrayMonth = [];
    if (Claim_Period_Type === "M") {
      arrayMonth = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return (
        <select
          className="form-control"
          name="Claim_Period_Month"
          onChange={this.handleChangeInput.bind(this)}
          value={this.state.Claim_Period_Month}
          disabled
        >
          <option value="">- Select Month -</option>
          {arrayMonth.map((item, index) => (
            <option key={index} value={index + 1}>
              {item}
            </option>
          ))}
        </select>
      );
    } else if (Claim_Period_Type === "Q") {
      arrayMonth = [1, 2, 3, 4];
      return (
        <select
          className="form-control"
          name="Claim_Period_Month"
          onChange={this.handleChangeInput.bind(this)}
          value={this.state.Claim_Period_Month}
          disabled
        >
          <option value="">- Select Month -</option>
          {arrayMonth.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>
      );
    }
  };

  renderClaimInfo = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light">Claim Info</div>

        <div className="card-body">
          <div className="row">{this.renderPeriod()}</div>
          <h5>Attachment</h5>
          <div className="row">
            <div className="col-md-6">
              {this.renderDocumentV2()}
              <div className="row mt-2">
                <div className="col-md-12">
                  {this.renderUploadSingle("REQUIRED")}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                {this.renderJumlahDisplay()}
                {this.renderAdditionalData()}
              </div>
              <div className="row">
                <div className="col-md-12">{this.renderButtonCalculate()}</div>
              </div>
            </div>
          </div>
          <hr />
          <div className='row'>
            <div className='col-md-6'>
              <div className="form-group row">
                  <label className="col-md-4 mt-1">Package</label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control col-md-8"
                    disabled={true}
                    name="package"
                    value={this.state.Claim_Package}
                  />
                </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1 col-form-label">
                  Payment Method
                </label>
                <div className="col-sm-8 mt-2">
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="Claim_PaymentMethod"
                      value="TRF"
                      onChange={(_) => _}
                      checked={true}
                    />{" "}
                    Transfer
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1">Activity</label>
                {this.renderLovActivity()}
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Reward Value</label>
                {this.renderInputDPP()}
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Tax No</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  name="Claim_TaxNo"
                  disabled={false}
                  value={this.state.Claim_TaxNo}
                  onChange={this.handleChangeInput.bind(this)}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPH Type</label>
                {this.renderLovPPhType()}
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPh</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_PPh"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_PPh}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Claim Nett</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_Nett"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_Nett}
                />
              </div>
              {/* <div className="form-group row">
                <label className="col-md-4 mt-1">Customer Receipt No</label>
                <input type="text" autoComplete="off" className="form-control col-md-8" disabled={false} name="Claim_CustomerReceipt" onChange={this.handleChangeInput.bind(this)} value={this.state.Claim_CustomerReceipt} />
              </div> */}
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1">Cost Center</label>
                {this.renderLovCostCenter()}
              </div>

              <div className="form-group row">
                <label className="col-md-4 mt-1">PPN Rate (%)</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_PPn"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.ppnrate}
                />
              </div>

              <div className="form-group row">
                <label className="col-md-4 mt-1">PPN</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={false}
                  name="Claim_PPn"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_PPn}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Tax Date</label>
                <DatePicker
                  selected={this.state.Claim_TaxDate}
                  dateFormat="d-MMM-yyyy"
                  className="form-control col-md-8"
                  popperPlacement="top-end"
                  onChange={this.handleTaxDate}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPh Rate (%)</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_PPhRate"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_PPhRate}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Total Claim (DPP)</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_TotalAmount"
                  value={this.state.Claim_TotalAmount}
                />
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1">SKB</label>
                <div className="col-sm-1 mt-2">
                  <div className="form-check form-check-inline">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      value="Y"
                      onChange={this.handleClickSKB.bind(this)}
                    />
                  </div>
                </div>
                {this.renderSKBAttachment()}
              </div>
              {this.renderSKBPeriod()}
            </div>
            <div className="col-md-6">{this.renderSKBNumber()}</div>
          </div>
        </div>
      </div>
    );
  };

  renderLovActivity = () => {
    return (
      <select
        className="form-control col-md-8"
        name="Claim_Activity"
        onChange={this.handleChangeInput.bind(this)}
      >
        <option value="">- Select Activty Program -</option>
        {this.state.lovActivity.map((item, index) => (
          <option key={index} value={item.activity_id}>
            {item.activity_name}
          </option>
        ))}
      </select>
    );
  };

  renderLovCostCenter = () => {
    return (
      <select
        className="form-control col-md-8"
        name="Claim_CostCenter"
        onChange={this.handleChangeInput.bind(this)}
      >
        <option value="">- Select Cost Center -</option>
        {this.state.lovCostCenter.map((item, index) => (
          <option key={index} value={item.cc_id}>
            {item.cost_center}
          </option>
        ))}
      </select>
    );
  };

  renderProduct = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light">
          <a
            className="text-decoration-none text-dark font-size-title"
            data-toggle="collapse"
            href="#multiCollapseExample5"
            role="button"
            aria-expanded="true"
            aria-controls="multiCollapseExample2"
          >
            Product&nbsp;
          <i className="fas fa-chevron-down font-size-small text-muted" />
          </a>
        </div>
        <div className="multi-collapse collapse" id="multiCollapseExample5">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6 font-weight-bold">Product Description</div>
              <div className="col-md-3 font-weight-bold">Budget</div>
            </div>
            {this.renderProductDetail()}
          </div>
        </div>
      </div>
    );
  };

  renderProductDetail = () => {
    return this.state.Product_List.map((item, index) => (
      <div key={index} className="row mt-2">
        <div className="col-md-6">
          <input
            type="text"
            className="form-control"
            value={item.item_description}
            disabled
          />
        </div>
        <div className="col-md-3">
          <input
            type="text"
            className="form-control"
            value={this.thousandSeparator(item.item_budget)}
            disabled
          />
        </div>
      </div>
    ));
  };

  handleChangeActual = (index, e) => {
    let value = e.target.value;
    let { Product_List } = this.state;

    Product_List[index].item_actual = this.thousandSeparator(value);
    this.setState(Product_List);
  };

  thousandSeparator = (value) => {
    if (!value || value.length === 0) return;

    value = value
      .toString()
      .replace(/,/g, "")
      .replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    if (!value || value.length === 0) {
      return;
    }
    value = value
      .toString()
      .replace(/,/g, "")
      .replace(/[^0-9.]/g, "");
    return value;
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { Document_Selected } = this.state;
    if (is_checked) {
      Document_Selected.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(Document_Selected, function (o) {
        return parseInt(o.program_doc_id) === parseInt(docId);
      });
      Document_Selected.splice(getIndex, 1);
    }
    this.setState(Document_Selected);
  };

  renderDocumentV2 = () => {
    let { fileRequired } = this.state;
    if (fileRequired.path.length === 0) {
      return this.state.Document_List.map((item, index) => (
        <div key={index} className="row">
          <div className="col-md-6" key={index}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={item.program_doc_id}
                onClick={this.handleClickDocument.bind(this)}
                id="defaultCheck1"
              />
              <label className="form-check-label" htmlFor="defaultCheck1">
                {item.document_name}
              </label>
            </div>
          </div>
        </div>
      ));
    } else {
      return this.state.Document_List.map((item, index) => (
        <div className="row">
          <div className="col-md-6" key={index}>
            <div className="">
              <label className="form-check-label" htmlFor="defaultCheck1">
                <i className="fa fa-check text-success" />
                &nbsp;{item.document_name}
              </label>
            </div>
          </div>
        </div>
      ));
    }
  };

  handleRemoveFile = () => {
    let { fileRequired } = this.state;
    fileRequired.filename = "";
    fileRequired.path = "";
    this.setState(fileRequired);
    this.setState({ Document_Selected: [] });
  };

  renderDocumentDisplay = () => {
    let { fileDisplay } = this.state;
    if (fileDisplay.path.length === 0) {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={1}
                name="Display_Attachment"
                onClick={this.handleClickDisplay.bind(this)}
                id="defaultCheck1"
              />
              <label className="form-check-label" htmlFor="defaultCheck1">
                Foto Display
              </label>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="">
              <label className="form-check-label" htmlFor="defaultCheck1">
                Foto Display
              </label>
            </div>
          </div>
        </div>
      );
    }
  };

  handleClickDisplay = (e) => {
    let is_checked = e.target.checked;
    let { fileDisplay } = this.state;
    if (is_checked) {
      this.setState({ Show_Display_Upload: true });
    } else {
      fileDisplay.filename = "";
      fileDisplay.path = "";
      this.setState({ Show_Display_Upload: false });
      this.setState(fileDisplay);
    }
  };

  renderUploadSingle = (type) => {
    if (type === "REQUIRED") {
      if (
        this.state.fileRequired.path &&
        this.state.fileRequired.path.length > 0
      ) {
        return (
          <div className="row">
            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-md-4">Upload Files</label>
                <a href={this.state.fileRequired.path}>
                  {this.state.fileRequired.filename}
                </a>{" "}
                &nbsp;{" "}
                <button
                  className="btn btn-danger rounded-circle"
                  onClick={this.handleRemoveFile.bind(this)}
                >
                  <i className="fa fa-trash" />
                </button>
              </div>
            </div>
          </div>
        );
      } else {
        if (
          this.state.Document_Selected.length ===
          this.state.Document_List.length
        ) {
          return (
            <div className="row">
              <div className="col-md-12">
                <div className="form-group row">
                  <label className="col-md-4">Upload Files</label>
                  <input
                    type="file"
                    className="form-control col-md-8"
                    data-type="REQUIRED"
                    onChange={this.handleUploadSingle.bind(this)}
                  />
                </div>
              </div>
            </div>
          );
        } else {
          return (
            <div className="text-danger mt-1">
              <i>
                <i className="fa fa-exclamation-triangle" /> select required
                document
              </i>
            </div>
          );
        }
      }
    }
  };

  handleCalculateDPP = () => {
    let { lovPackage } = this.state;
    let app = this;
    let currentPackage = _.find(lovPackage, function (o) {
      return o.package_name === app.state.Claim_Package;
    });
    console.log(currentPackage);
    let requiredJmlDisplay = parseInt(currentPackage?.jml_display) || 0;
    this.setState({ error: [] });
    if (this.state.Attachment_Display === "Y") {
      if (
        parseInt(this.state.Attachment_Jml_Display || 0) < requiredJmlDisplay
      ) {
        this.setState({
          error: [
            "Jumlah display kurang dari persyaratan (" +
              requiredJmlDisplay +
              ")",
          ],
        });
        window.scrollTo(0, 0);
        return false;
      }
    }

    this.calculateTotalClaim();
  };

  calculateTotalClaim = () => {
    let error = [];
    if (this.state.Claim_Period_Year === "") {
      error.push("Select Year of Period");
    }
    if (this.state.Claim_Period_Type === "") {
      error.push("Claim Period Type is required, ex: Monthly / Quarterly");
    }
    if (this.state.Claim_Period_Month === "") {
      error.push("Select Month / Quarter");
    }
    if (error.length > 0) {
      window.scrollTo(0, 0);
      this.setState({ error: error });
      return false;
    }

    let url = "/api/traces_chd/v1/claim/data-insentif";
    let param = {
      source_dwh: this.state.Claim_Source_DWH || "N",
      period_month: this.state.Claim_Period_Month || "",
      period_year: this.state.Claim_Period_Year || "",
      customer_id: this.state.Customer_Id,
      program_name: this.state.General_ProgramType || "",
      package: this.state.Claim_Package || "",
      pkp_badan: this.state.Customer_PKP_Badan || "N",
      potong_pajak: this.state.Customer_Potong_Pajak || "N",
      skb: this.state.Claim_SKB || "N",
      skb_start: this.state.Claim_SKB_Start_Date || "",
      skb_end: this.state.Claim_SKB_End_Date || "",
      dpp: this.removeSeparator(this.state.Claim_DPP || 0),
      period_type: this.state.Claim_Period_Type,
      pph_type: this.state.Claim_PPh_Type,
      pph_rate: this.state.Claim_PPhRate,
      skp_number: this.state.General_SkpNumber || ''
    };

    this.setState({ loading: true });
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data;
        let dpp =
          (this.state.Claim_Source_DWH === "Y" || this.state.General_ProgramType == 'BRANDING RELASI' )
            ? data.reward.TOTAL_REWARD
            : this.state.Claim_DPP;
        this.setState({
          loading: false,
          Claim_PPn: this.thousandSeparator(data.claim.ppn || "0"),
          Claim_DPP: this.thousandSeparator(dpp || "0"),
          Claim_PPhRate: data.claim.pph_rate,
          Claim_PPh: this.thousandSeparator(data.claim.pph || "0"),
          Claim_PPh_Type: data.claim.pph_type,
          Claim_TotalAmount: this.thousandSeparator(
            data.claim.total_claim || "0"
          ),
          Claim_Bukpot: data.claim.bukpot,
          Claim_Nett: this.thousandSeparator(data.claim.nett || 0),
        });
      }.bind(this),
      error: function (e) {
        this.setState({
          loading: false,
          error: [e.response.data.message || "Failed to get data incentif"],
        });
      }.bind(this),
    });
  };

  renderButtonCalculate = () => {
    if (this.state.Claim_Source_DWH === "Y") {
      return (
        <span>
          <button
            type="button"
            className="btn btn-success btn-block"
            onClick={this.handleCalculateDPP.bind(this)}
          >
            <i className="fa fa-gift" /> GET REWARDS
          </button>
        </span>
      );
    }
  };

  renderJumlahDisplay = () => {
    if (this.state.Attachment_Display === "Y") {
      return (
        <div className="col-md-6">
          <div className="form-group row">
            <label className="col-md-6 mt-1">Jumlah Display</label>
            <input
              type="text"
              className="form-control col-md-6"
              autoComplete="off"
              name="Attachment_Jml_Display"
              value={this.state.Attachment_Jml_Display}
              onChange={this.handleChangeInput.bind(this)}
            />
          </div>
        </div>
      );
    }
  };

  renderAdditionalData = () => {
    if (this.state.Attachment_Data === "Y") {
      return (
        <div className="col-md-6">
          <div className="form-group row">
            <label className="col-md-6 mt-1">Jumlah Data</label>
            <input
              type="text"
              className="form-control col-md-6"
              autoComplete="off"
              name="Attachment_Jml_Data"
              value={this.state.Attachment_Jml_Data}
              onChange={this.handleChangeInput.bind(this)}
            />
          </div>
        </div>
      );
    }
  };

  renderButton = () => {
    return (
      <div className="row">
        <div className="col-md-3">
          <button
            type="button"
            className="btn btn-primary btn-block"
            onClick={this.handleSubmit.bind(this)}
          >
            <i className="fa fa-save" /> Submit
          </button>
        </div>
        <div className="col-md-3">
          <button
            type="button"
            className="btn btn-warning btn-block"
            onClick={() => {
              this.props.history.push("/admin/claim-chd/submit");
            }}
          >
            <i className="fa fa-arrow-left" /> Back
          </button>
        </div>
      </div>
    );
  };

  formValidation = () => {
    let { error } = this.state;
    error = [];

    if (this.state.Claim_Period_Year === "") {
      error.push("Select Year of Period");
    }
    if (this.state.Claim_Period_Type === "") {
      error.push("Claim Period Type is required, ex: Monthly / Quarterly");
    }
    if (this.state.Claim_Period_Month === "") {
      error.push("Select Month / Quarter");
    }
    if (this.state.Claim_Activity === "") {
      error.push("Claim activity is required");
    }
    if (this.state.Claim_CostCenter === "") {
      error.push("Claim cost center is required");
    }
    if (this.state.Claim_DPP === "" || this.state.Claim_DPP === "0") {
      error.push("Claim DPP is required");
    }
    if(!this.state.Claim_PPh_Type || this.state.Claim_PPh_Type == 'Tidak Potong PPh'){
      error.push("PPh Type is required")
    }
    // if (this.state.Claim_TaxDate === "") {
    //   error.push('Claim tax date is required')
    // }
    // if (this.state.Claim_TaxNo === "" || this.state.Claim_TaxNo.length === 0) {
    //   error.push('Claim tax no is required')
    // } else {
    //   let count = this.state.Claim_TaxNo.replace(/\.|-/g, "");
    //   if (count.length < 16 || count.length > 16) {
    //     error.push("Invalid Tax No, must be contain 16 digits (exclude . & -)");
    //   }
    // }
    if (this.state.Claim_SKB === "Y") {
      if (!this.state.fileSKB.filename) {
        error.push("Please attach document for exemption certificate");
      }
      if (this.state.Claim_SKBNumber === "") {
        error.push("SKB Number is empty");
      }
    }

    // if (this.state.Attachment_Display === "Y") {
    //   if (
    //     this.state.Attachment_Jml_Display === "" ||
    //     this.state.Attachment_Jml_Display === "0"
    //   ) {
    //     error.push("Jumlah display is required");
    //   }
    // }

    if (this.state.Document_Selected.length < this.state.Document_List.length) {
      error.push("Please complete the required attachments");
    } else {
      if (this.state.fileRequired.path.length === 0) {
        error.push("Upload the required attachment");
      }
    }

    // Nett must be higher than 10K
    if (parseInt(this.removeSeparator(this.state.Claim_Nett) || 0) < 10000) {
      error.push("Claim Nett must be more than equal to 10,000")
    }
    
    if (error.length > 0) {
      window.scrollTo(0, 0);
      this.setState({ error: error });
      return false;
    } else {
      return true;
    }
  };
  handleSubmit = () => {
    if (this.formValidation()) {
      let url = "/api/traces_chd/v1/claim/submit";
      let { id } = this.props.match.params;
      let param = {
        program_customer_id: id,
        dpp: this.removeSeparator(this.state.Claim_DPP),
        ppn: this.removeSeparator(this.state.Claim_PPn),
        pph: this.removeSeparator(this.state.Claim_PPh),
        pph_type: this.state.Claim_PPh_Type,
        pph_rate: this.state.Claim_PPhRate,
        total: this.removeSeparator(this.state.Claim_TotalAmount),
        payment_method: this.state.Claim_PaymentMethod,
        bank_name: this.state.Customer_BankName,
        bank_account_no: this.state.Customer_BankAccountNo,
        bank_account_owner: this.state.Customer_BankAccountOwner,
        npwp: this.state.Customer_NPWP,
        npwp_name: this.state.Customer_NPWPName,
        npwp_address: this.state.Customer_NPWPAddress,
        skb: this.state.Claim_SKB,
        skb_number: this.state.Claim_SKBNumber,
        fileSKB: this.state.fileSKB,
        tax_no: this.state.Claim_TaxNo,
        tax_date: this.state.Claim_TaxDate,
        fileRequired: this.state.fileRequired,
        user_id: this.state.user.user_id,
        org_initial: this.state.General_PrincipalCode,
        // branch_code: this.state.user.org_name,
        branch_code: this.state.Claim_Branch,
        jml_display: this.state.Attachment_Jml_Display,
        receipt_no: this.state.Claim_CustomerReceipt,
        activity: this.state.Claim_Activity,
        ccid: this.state.Claim_CostCenter,
        additional_data: this.state.Attachment_Jml_Data || 0,
        skb_start_date: this.state.Claim_SKB_Start_Date,
        skb_end_date: this.state.Claim_SKB_End_Date,
        bukpot: this.state.Claim_Bukpot,
        nett: this.removeSeparator(this.state.Claim_Nett),
        data_insentif: this.state.dataInsentif || [],
        customer_name: this.state.Customer_Name, // New Additional Param To Count Insentif
        customer_id: this.state.Customer_Id,
        program_name: this.state.General_ProgramType,
        package: this.state.Claim_Package,
        branch: this.state.Claim_Branch,
        program_start: this.state.General_StartDate,
        program_end: this.state.General_EndDate,
        period_type: this.state.Claim_Period_Type,
        period_year: this.state.Claim_Period_Year,
        period_selected_num: this.state.Claim_Period_Month,
        requester: this.state.user.username,
        email: this.state.user.username,
        pkp_badan: this.state.Customer_PKP_Badan,
        potong_pajak: this.state.Customer_Potong_Pajak,
        ppnrate : this.state.ppnrate,
        notes: this.state.notes,
        skp_number: this.state.General_SkpNumber,
        program_id: this.state.General_Program_ID
      };

      this.setState({ loading: true });
      request.postCHD(url, param, {
        success: function (response) {
          let msg = response.data.message || "Claim berhasil disubmit";
          this.setState({
            loading: false,
            success: msg,
          });
          window.scrollTo(0, 0);

          let app = this;
          window.setTimeout(() => {
            app.props.history.push("/admin/claim-chd/submit");
          }, 3000);
        }.bind(this),
        error: function (e) {
          window.scrollTo(0, 0);
          console.log(e.response.data);
          this.setState({
            loading: false,
            error: [e.response.data.message],
          });
        }.bind(this),
      });
    }
  };

  renderLovPPhType = () => {
    return (
      <select
        className="form-control col-md-8"
        name="Claim_PPh_Type"
        value={this.state.Claim_PPh_Type}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option value="">- Select PPh Type -</option>
        {this.state.lovPPhType.map((item, index) => (
          <option value={item.pph_type} key={index}>
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  renderPeriod = () => {
    let { Claim_Source_DWH } = this.state;
    if (Claim_Source_DWH === "Y") {
      return (
        <div className="col-md-12">
          <h5>Period</h5>
          <div className="form-group row">
            <div className="col-md-4">{this.renderYear()}</div>
            <div className="col-md-4">{this.renderLovPeriod()}</div>
            <div className="col-md-4">{this.renderMonth()}</div>
          </div>
        </div>
      );
    }
  };

  handleDetailInsentif = () => {
    let error = [];
    if (this.state.Claim_Period_Year === "") {
      error.push("Select Year of Period");
    }
    if (this.state.Claim_Period_Type === "") {
      error.push("Claim Period Type is required, ex: Monthly / Quarterly");
    }
    if (this.state.Claim_Period_Month === "") {
      error.push("Select Month / Quarter");
    }
    if (error.length > 0) {
      window.scrollTo(0, 0);
      this.setState({ error: error });
      return false;
    }

    let url = "/api/traces_chd/v1/claim/detail-insentif";
    let param = {
      customer_name: this.state.Customer_Name,
      customer_id: this.state.Customer_Id,
      program_name: this.state.General_ProgramType,
      package: this.state.Claim_Package,
      branch: this.state.Claim_Branch,
      program_start: this.state.General_StartDate,
      program_end: this.state.General_EndDate,
      period_type: this.state.Claim_Period_Type,
      period_selected_num: this.state.Claim_Period_Month,
      period_year: this.state.Claim_Period_Year,
    };
    this.setState({ loading: true });
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data;

        // set detail insentif
        this.setState({ loading: false, dataInsentif: data.line });
        if (data.fullpath) {
          window.open(data.fullpath, "_blank");
        }
      }.bind(this),
      error: function (e) {
        this.setState({
          loading: false,
          error: [e.response.data.message || "Failed to get detail incentif"],
        });
      }.bind(this),
    });
  };

  renderInputDPP = () => {
    let { Claim_Source_DWH } = this.state;
    if (Claim_Source_DWH === "Y") {
      return (
        <div className="input-group col-md-8 p-0">
          <input
            type="text"
            autoComplete="off"
            disabled={this.state.Claim_Source_DWH === "Y" ? true : false}
            className="form-control"
            name="Claim_DPP"
            value={this.state.Claim_DPP}
            onChange={this.handleChangeInput.bind(this)}
          />
          {/* <button type="button" className="btn btn-info col-md-3">View Docs</button> */}
          <div className="input-group-append">
            <button
              className="btn btn-primary"
              onClick={this.handleDetailInsentif.bind(this)}
              type="button"
            >
              View Docs
            </button>
          </div>
        </div>
      );
    } else {
      return (
          <input
            type="text"
            autoComplete="off"
            disabled
            className="form-control col-md-8"
            name="Claim_DPP"
            value={this.state.Claim_DPP}
            onChange={this.handleChangeInput.bind(this)}
          />
        // <div className="input-group col-md-8 p-0">
        //   <input
        //     type="text"
        //     autoComplete="off"
        //     disabled={this.state.Claim_Source_DWH === "Y" ? true : false}
        //     className="form-control col-md-8"
        //     name="Claim_DPP"
        //     value={this.state.Claim_DPP}
        //     onChange={this.handleChangeInput.bind(this)}
        //   />
        //   {this.state.General_ProgramType != 'BRANDING RELASI' && 
        //     <div className="input-group-append">
        //       <button
        //         className="btn btn-primary"
        //         onClick={this.calculateTotalClaim.bind(this)}
        //         type="button"
        //       >
        //         <i className="fa fa-calculator" /> Calculate
        //       </button>
        //     </div>
        //   }
        // </div>
      );
    }
  };

  handleSKBDateStart = (date) => {
    let { Claim_DPP } = this.state;
    this.setState({ Claim_SKB_Start_Date: date });

    let app = this;
    console.log(Claim_DPP);
    if (parseInt(this.removeSeparator(Claim_DPP || 0)) > 0) {
      window.setTimeout(() => {
        app.calculateTotalClaim();
      }, 200);
    }
  };

  handleSKBDateEnd = (date) => {
    let { Claim_DPP } = this.state;
    this.setState({ Claim_SKB_End_Date: date });

    let app = this;
    console.log(Claim_DPP);
    if (parseInt(this.removeSeparator(Claim_DPP || 0)) > 0) {
      window.setTimeout(() => {
        app.calculateTotalClaim();
      }, 200);
    }
  };

  calculateClaim = () => {
    alert("Wait...");
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <form className="form-horizontal">
                  <div className="card card-info">
                    <div className="card-body">
                      {this.renderGeneralInfo()}
                      {this.renderProduct()}
                      {this.renderCustomerInfo()}
                      {this.renderClaimInfo()}
                      {/* {this.renderAttachment()} */}
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Notes
                            </label>
                            <div className="col-sm-8">
                              <textarea
                                cols="10"
                                rows="3"
                                className="form-control"
                                name="notes"
                                onChange={this.handleChangeInput.bind(this)}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.renderButton()}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default ClaimDetailCHD